import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=2ce7cbac&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"
import style1 from "./Contact.vue?vue&type=style&index=1&id=2ce7cbac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce7cbac",
  null
  
)

export default component.exports